import $ from 'jquery';
import async from 'async';
import {_str} from './util';
import {TR} from './test-results';
import c11n from 'wtg/c11n';

//TODO: refine this. probably avoid name "orbit" and use a better names.
export var WTGFIXEDLINE = (function(){
 var colors = {
  "unknown":"#C5C5C5",
  "ok": "#B7E200",
  "warn": "#FAAA0C",
  "prob": "#F52201",
  "skip": "#C5C5C5"
 };
 var components = {
  device: {n:"device",t_id:"test_result_header_device",e:"unknown"}, internet: {n:"internet",t_id:"test_result_header_internet",e:"unknown"},
  router: {n:"wifi_router",t_id:"test_result_header_wifi_router",e:"unknown"},
  fixed_line: {n:"fixed_line",c1:"router",c2:"internet",t_id:"test_result_header_fixed_line",e:"unknown"},
  wifi: {n:"wifi",c1:"device",c2:"router",t_id:"test_result_header_wifi_network",e:"unknown"}
 };
 var help_mode_info = {
  device : {t_id:"help_mode_device_title",d_id:"help_mode_device_desc",title: undefined/*_str("help_mode_device_title")*/,desc:undefined/*_str("help_mode_device_desc")*/},
  wifi : {t_id:"help_mode_wifi_title",d_id:"help_mode_wifi_desc",title: undefined/*_str("help_mode_wifi_title")*/,desc: undefined/*_str("help_mode_wifi_desc")*/},
  router : {t_id:"help_mode_router_title",d_id:"help_mode_router_desc",title: undefined/*_str("help_mode_router_title")*/,desc: undefined/*_str("help_mode_router_desc")*/},
  fixed_line : {t_id:"help_mode_provider_line_title",d_id:"help_mode_provider_line_desc",title: undefined/*_str("help_mode_provider_line_title")*/,desc: undefined/*_str("help_mode_provider_line_desc")*/},
  internet : {t_id:"help_mode_internet_title",d_id:"help_mode_internet_desc",title: undefined/*_str("help_mode_internet_title")*/,desc: undefined/*_str("help_mode_internet_desc")*/},
 };
 function get_component_name(c1,c2) {
  for(var comp in components) {
   if(components[comp].c1 && components[comp].c2 && components[comp].c1 == c1, components[comp].c2 == c2) return comp;
  }
 }
 function reset() {
  for(var comp in components) {
   //L.trace("comp-"+comp);
   $("#lv_"+comp).css("background",colors.unknown);
   components[comp].e = "unknown";
  }
 }
 function set_status(obj) {
  //L.trace("set_status - "+JSON.stringify(obj));
  var comp = obj.c1;
  if(obj.con) comp = get_component_name(obj.c1,obj.c2);
  //L.trace("set_status - comp - "+comp);
  if(components[comp] && components[comp].e) components[comp].e = obj.r;
  $("#lv_"+comp).css("background",colors[obj.r]);
 }
 function help_mode_desc(id){
  return _str(help_mode_info[id].d_id);
 }
 return {
  reset:reset,
  set_status:set_status,
  components: components,
  help_info:help_mode_desc,
 };
})();
export var WTGORBIT = (function() {
 //evaluation mapping for Android evaluation values to Javascript
 //Android 3-Result impossible 4-OK, 5-Warning, 6-Problem
 //JS 0-OK, 1-Warning, 2-Problem
 // this mapping is to handle different values from different platforms
 var resultEvaluationMapping = {"eval_4":0,"eval_5":1,"eval_6":2,"eval_3":1};
 var stateForStatusBarColor;
 var reportScreenData;
 var arcs = {};
 var d = {
  w:undefined, h:undefined,
  orbit:undefined,
  //t - title
  //t_id - string ids for the titles. use these ids to fetch from stringz while creating orbit
  orbiters: {
   device: {n:"device", t:_str("test_result_header_device"), t_id:"test_result_header_device", e:"unknown",b:"unknown",index:0,img: WTG.img("home_device.svg"),reportScreenIcon:"img/rs_device.png",pos:0},
   network: {n:"mobile_bs", t:_str("test_result_header_base_station"), t_id:"test_result_header_base_station", e:"unknown",b:"unknown",index:1,img: WTG.img("home_network.svg"),reportScreenIcon:"img/rs_network.png",pos:90},
   internet: {n:"internet", t:_str("test_result_header_internet"), t_id:"test_result_header_internet", e:"unknown",b:"unknown",index:2,img: WTG.img("home_internet.svg"),reportScreenIcon:"img/rs_internet.png",pos:180},
   router: {n:"wifi_router", t:_str("test_result_header_wifi_router"), t_id:"test_result_header_wifi_router", e:"unknown",b:"unknown",index:3,img: WTG.img("home_router.svg"),reportScreenIcon:"img/rs_router.png",pos:270}
  },
  arcs : {
   wifi: {n:"wifi",a:"device_router", t_id:"test_result_header_wifi_network"},
   fixed_line: {n:"fixed_line",a:"internet_router", t_id:"test_result_header_fixed_line"},
   mobile: {n:"mobile",a:"device_network", t_id:"test_result_header_mobile_network"},
   mobile_bb: {n:"mobile_bb",a:"network_internet", t_id:"test_result_header_mobile_backbone"}
  }
 };
 var help_mode_info = {
  device : {t_id:"help_mode_device_title",d_id:"help_mode_device_desc",title: undefined/*_str("help_mode_device_title")*/,desc:undefined/*_str("help_mode_device_desc")*/},
  wifi_network : {t_id:"help_mode_wifi_title",d_id:"help_mode_wifi_desc",title: undefined/*_str("help_mode_wifi_title")*/,desc:undefined/*_str("help_mode_wifi_desc")*/},
  router : {t_id:"help_mode_router_title",d_id:"help_mode_router_desc",title: undefined/*_str("help_mode_router_title")*/,desc:undefined/*_str("help_mode_router_desc")*/},
  provider_line : {t_id:"help_mode_provider_line_title",d_id:"help_mode_provider_line_desc",title: undefined/*_str("help_mode_provider_line_title")*/,desc:undefined/*_str("help_mode_provider_line_desc")*/},
  internet : {t_id:"help_mode_internet_title",d_id:"help_mode_internet_desc",title: undefined/*_str("help_mode_internet_title")*/,desc:undefined/*_str("help_mode_internet_desc")*/},
  mobile_line : {t_id:"help_mode_mobile_line_title",d_id:"help_mode_mobile_line_desc",title: undefined/*_str("help_mode_mobile_line_title")*/,desc:undefined/*_str("help_mode_mobile_line_desc")*/},
  network : {t_id:"help_mode_network_title",d_id:"help_mode_network_desc",title: undefined/*_str("help_mode_network_title")*/,desc:undefined/*_str("help_mode_network_desc")*/},
  mobile_network :{t_id:"help_mode_mobile_network_title",d_id:"help_mode_mobile_network_desc",title: undefined/*_str("help_mode_mobile_network_title")*/,desc:undefined/*_str("help_mode_mobile_network_desc")*/},
  center : {t_id:"",d_id:"help_mode_center_desc",title: '',desc: undefined/*_str("help_mode_center_desc")*/},
 };
 var arcData = {};
 var ConnectionLineColors={
  "unknown":_TDC ? "#76817E" :"#C5C5C5",
  "ok": _TDC ? "#3CB84D":"#B7E200",
  "warn": "#FAAA0C",
  "prob": _TDC ? "#E8241A" :"#F52201",
  "skip": "#C5C5C5"
 };

 //Get orbiters count
 function getOrbitersCount() {
  /* XXX: how is this whole code different from Object.keys(d.orbiters).length ? */
  var count = 0;
  for(var i in d.orbiters) {
   /* XXX: When is the condition below not met? */
   if(d.orbiters.hasOwnProperty(i)) {
    count++;
   }
  }
  return count;
 }
 var myCanvas;
 var sWidthF;
 var canvasRadius;
 var canvasHalf;
 var canvasExt;
 var ringDimention;
 var imageCenter;
 var offsetRegion;
 var sWidth;

 // Create orbit and orbiters when document is ready
 function CreateOrbit(){
  L.trace("CreateOrbit");
  var re_evaluate = false;
  if(bOrbitReady) re_evaluate = true;
  bOrbitReady = false;
  d.orbit = new orbit();
  if(!_TDC) angular.element($('#appScreensContainer')).scope().BGImage="img/background_home_cv.jpg";
  if(!_TDC) $("#mainScreen_help_text").hide();
  sWidth = /* $('#parent-container').innerWidth() || */ $(document.body).innerWidth() || getScreenWidth();
  var sHeight = /* $('#parent-container').innerHeight() || */ $(document.body).innerHeight() || getScreenHeight();
  L.trace("CreateOrbit-parent container - height--"+sHeight+"--sWidth-"+sWidth);
  if($("#container"))$("#container").html(' <canvas id="myCanvasId" class="rotating" style=""></canvas><div id="arcOverlay"></div><div id="arc_help_bubble"></div>');
  if(sHeight && sWidth) _portrait = sHeight > sWidth; /*screen height is greater value _portrait "true" lesser value _portrait "false" */
  if(WTG.help_mode) {
   if(sHeight<620)$(".ms_help_info").addClass("help_text_limited_lines");
   else $(".ms_help_info").removeClass("help_text_limited_lines");
  }  
  sWidthF = calculateOrbitWidth(sWidth,sHeight);
  checkClientCoordinates(sWidth);
  //if(!_TDC) onMovingButtonWithTouch();
  var radius =Math.round(sWidthF/2);
  $("#container").css('width',sWidthF+'px').css('height',sWidthF+'px');
  var vheight = c11n.features.vpn ? sWidthF/3+15 : 0;
  ringDimention= Math.round(sWidthF*.28);
  var sWtop = vheight + (ringDimention+4)/2;
  var sWleft = (ringDimention+5)/2;
  $("#showWarning").css('width',(sWidthF-ringDimention)+'px').css('height',(sWidthF-ringDimention)+'px');
  $("#showWarning").css({position:"absolute", top:sWtop +"px",left:sWleft+"px"});
  $(".canvasContainer").css('width',sWidthF+'px').css('height',sWidthF+vheight+'px');
  var or_width =(sHeight<600)? sWidth*0.8 : sWidth ;
  $(".help_mode_canvasContainer").css('width',or_width+'px').css('height',or_width+'px');
  $("#mainScreen_help_text").html( _str("help_text_tdc"));
  imageCenter= Math.round(ringDimention*.93);
  offsetRegion = Math.round(imageCenter/1.6);
  canvasHalf= Math.round(sWidthF/2-offsetRegion);
  canvasExt = Math.round(sWidthF/2+offsetRegion);
  for(var i in help_mode_info){
   help_mode_info[i].title = _str(help_mode_info[i].t_id);
   help_mode_info[i].desc = _str(help_mode_info[i].d_id);
  }
  if(c11n.features.vpn) {
   addVpnOrbit();
  } else {
   $("#vpnStatus").css("visibility","hidden");
   $("#vpnOrbit").css("display","none");
   $('#deviceToRouter').remove();
   $('#routerToInternet').remove();
   $(".internetClass").attr("src","img/Unified/home_internet.svg");
  }

  $("#TextInsideCanvasId").css('width',sWidthF+'px').css('height',sWidthF+'px');

  setArcRegions();

  myCanvas = document.getElementById("myCanvasId");

  var canvasOffset = $("#myCanvasId").offset();
  if(C11N.tooltips){
   myCanvas.addEventListener('mousemove', function on_canvas_mousemove(evt) { handleArcsMousehover(evt,canvasOffset) }, false);
   document.getElementById("showWarning").addEventListener('mousemove', function on_warning_mousemove(evt) { onManageCenterTextTooltips(evt,canvasOffset) }, false);
  }

  myCanvas.width=sWidthF+6;
  myCanvas.height=sWidthF+6;

  d.orbit.init("container", radius);
  var step = 360.0/getOrbitersCount();
  var angle = -step;

  for(var o in d.orbiters){
   d.orbiters[o].t = _str(d.orbiters[o].t_id);
   d.orbit.addOrbiter(o, d.orbiters[o].t, angle+=step, d.orbiters[o].e,d.orbiters[o].b,d.orbiters[o].img);
  }
  // update titles for arcs
  for(var arc in d.arcs) d.arcs[arc].t = _str(d.arcs[arc].t_id);
  bOrbitReady = true;
  L.trace("CreateOrbit - ready");
  async.setImmediate(NativeAPI.onOrbitReady.bind(NativeAPI));
  $('#myCanvasId').click(function on_canvas_click(e) {
   if(WTG.help_mode){
    handle_help_mode_text_on_arcs(e,true);
    return;
   }
   $("#arcOverlay").css("visibility","hidden");
   var x = e.offsetX;
   var y = e.offsetY;
   //offset regions for adding click events to canvas area
   var touchAreaLimitX=2;
   var touchAreaLimitY=4;
   var touchAreaX=3;
   var ftrbg;
   /*Here we divide canvas area into 4 parts for 4 arcs
   and in that we divide one of the part (for eg: wifi - arc connecting device and router) into three sub-parts and one is arc surrounded area where the click event
   is added (else condition) and remaining parts where the click event is excluded (if condition part).

   here x and y returns offset regions for adding click events to canvas area.

   and offsetRegion is half of the component(component is device, router, network, internet) width, as the click area of the arc should be excluding half of these components
   canvasExt -> half of the canvas width + offsetRegion
   canvasHalf -> half of the canvas width - offsetRegion

   We took those four(var touchAreaLimitX,var touchAreaLimitY,var touchAreaX,var touchAreaY) variables to
   subtract and add some values based on the various devices dimensions and
   to get more accuracy for click event on the arc.*/
   if( x>canvasExt-touchAreaLimitX && x<(sWidthF-touchAreaLimitY)
   && y>(canvasExt-touchAreaLimitX) && y<(sWidthF-touchAreaLimitY) ) {
    if( x<(sWidthF-offsetRegion) && y<(sWidthF-offsetRegion) ) {
     // eslint-disable-line no-empty
    }else ftrbg = {c:"wifi",a:"device_router"};
   }else if( x>(canvasExt-touchAreaLimitX) && x <(sWidthF-touchAreaLimitY)
   && y>touchAreaLimitY && y<(canvasHalf+touchAreaX) ) {
    if( x<(sWidthF-offsetRegion) && y>(canvasHalf-offsetRegion) ) {
     // eslint-disable-line no-empty
    }else ftrbg = {c:"fixed_line",a:"internet_router"};
   }else if( x>touchAreaLimitY && x <(canvasHalf+touchAreaX)
   && y>(canvasExt-touchAreaLimitX) && y<(sWidthF-touchAreaLimitY) ) {
    if(! WTG.capabilities.mobile) return;
    if( x>(canvasHalf-offsetRegion) && y<(sWidthF-offsetRegion) ) {
     // eslint-disable-line no-empty
    }else ftrbg = {c:"mobile",a:"device_network"};
   }else if( x>touchAreaLimitY && x<(canvasHalf+touchAreaX)
   && y>touchAreaLimitY && y<(canvasHalf+touchAreaX) ) {
    if(! WTG.capabilities.mobile) return;
    if( x>(canvasHalf-offsetRegion) && y>(canvasHalf-offsetRegion) ) {
     // eslint-disable-line no-empty
    }else ftrbg = {c:"mobile_bb",a:"network_internet"};
   }
   if(!ftrbg) return;
   //var ad = arcData[ftrbg.a];
   //if(!ad) throw new Error("invalid arc while handling a click");
   showResultsScreen(ftrbg.c);
  });

  function addVpnOrbit(){
   var template = '<div id="vpnOrbitRing"><div  class="ring unknown" id="sOrbit" style="text-align:center;"><img id="corpServerIcon" class="imageAlignementClass"  src="" /></div></div><div id="vpnOrbitLine"><div id="vpnOrbitArc"><img class="lockImg"  src="img/lockIcon.svg" /></div></div>';
   $("#vpnOrbit").css("display","block");
   document.getElementById("vpnOrbit").innerHTML = template;
   $("#vpnStatus").css("visibility","visible");
   $("#vpnOrbit").css('width',sWidthF+'px').css('height',vheight+'px');
   $("#vpnOrbitRing").css('width',sWidthF+'px').css('height',(ringDimention/2)+'px');
   $("#vpnOrbitLine").css('width',sWidthF+'px').css('height',(vheight-ringDimention)+'px');
   $(".ring").css('width',ringDimention+'px').css('height',ringDimention+'px');
   var sorbit_left = Math.round(radius-($("#sOrbit").outerWidth()/2.0));
   $("#sOrbit").css({position:"absolute",left:sorbit_left+"px", top:-(ringDimention/2)+"px"});
   $("#vpnOrbitArc").css({position:"absolute",left:radius-3+"px",width:"6px",height:(vheight-ringDimention)+"px"});
  }
  L.trace("_bEvaluationSkipped - "+_bEvaluationSkipped);
  if(C11N.check_mobile_capability) setMobileComponents(WTG.capabilities.mobile);
  if((re_evaluate || _bEvaluationSkipped) && Object.keys(TR.results).length) {
   L.warn("result evaluation was skipped. do it now.");
   TR.evaluate();
  }
  if(H2GAPP && H2GAPP.permissions()) H2GAPP.checkNotifications();
 }

 function setCorpServerColor(evaluation) {
  $("#sOrbit").addClass(evaluation);
 }

 function setCorpServerIcon(path) {
  $("#corpServerIcon").attr("src",path);
 }
 function showLockIcon(component,bShow){
  if(TR.testGroupMapping[component].group1 == TR.testGroupMapping[component].group2) {
   if(component == 'internet'){
    $(".internetClass").attr("src",bShow?"img/home_internet_vpn_on.svg":"img/Unified/home_internet.svg");
    $("#vpnStatus").css("visibility",bShow?"visible":"hidden");
    if(bShow) $("#vpnStatusMsg").text("VPN CONNECTED");
   }
  }
  else {
   // TODO: later add logic to show/hide lock icons
   //arcs
   if(component == 'wifi'){
    $('#container').append($('<div id="deviceToRouter" class="lockIconClass"><img src="img/lockIcon.svg" /></div>'));
    $('#deviceToRouter').css('left', Math.round(sWidthF-((1/8)*sWidthF))+'px').css('top',Math.round(sWidthF*(3/3.9))+"px");
   }
   else if(component == 'fixed_line'){
    $('#container').append($('<div id="routerToInternet" class="lockIconClass"><img src="img/lockIcon.svg" /></div>'));
    $('#routerToInternet').css('left',Math.round(sWidthF-((1/8)*sWidthF))+'px').css('top',Math.round(sWidthF/7)+"px");
   }
   else if(component == 'mobile_bb'){
    $('#container').append($('<div id="networkToInternet" class="lockIconClass"><img src="img/lockIcon.svg" /></div>'));
    $('#networkToInternet').css('left',Math.round(sWidthF/12)+'px').css('top',Math.round(sWidthF/7)+"px");
   }
   else if(component == 'mobile'){
    $('#container').append($('<div id="deviceToNetwork" class="lockIconClass"><img src="img/lockIcon.svg" /></div>'));
    $('#deviceToNetwork').css('left',Math.round(sWidthF/12)+'px').css('top',Math.round(sWidthF*(3/3.9))+"px");
   }
  }
 }

 var arcRegions = {};
 function setArcRegions() {
  /*
  {"device_router":{"x":canvasExt,"y":canvasExt},
  "device_network":{"x":arcRegionOffset,"y":canvasExt},
  "router_internet":{"x":canvasExt,"y":arcRegionOffset},
  "network_internet":{"x":arcRegionOffset,"y":arcRegionOffset}};
  */
  var arcRegionOffset=1; //offset value to clear arcs
  var clearArcArea = sWidthF/2;
  arcRegions.device_router = {};
  arcRegions.device_router.x=clearArcArea;
  arcRegions.device_router.y=clearArcArea;

  arcRegions.device_network = {};
  arcRegions.device_network.x=arcRegionOffset;
  arcRegions.device_network.y=clearArcArea;

  arcRegions.router_internet = {};
  arcRegions.router_internet.x=clearArcArea;
  arcRegions.router_internet.y=arcRegionOffset;

  arcRegions.network_internet = {};
  arcRegions.network_internet.x=arcRegionOffset;
  arcRegions.network_internet.y=arcRegionOffset;
 }
 //Orbit: Orbit around which orbiters revolutes
 function orbit() {
  var cont;
  var prop = {w:undefined, h:undefined, r:undefined, orbiters:{}};
  var angler = {};

  // Initialize the orbit
  /* TODO: OOOOBVIOUSLY it's a crime to accept callback and never return it */
  this.init = function orbit_init(container, radius/*, cb*/) {
   // Pre-calculate angle mapping from degrees to radians
   var factor = Math.PI/180.0;
   for(var angled=0; angled<=360; angled++) {
    angler[angled] = angled*factor;
   }
   cont = $("#"+container);
   prop = {w:cont.width(), h:cont.height(), r:radius, orbiters:{}};
  };

  // Add an orbiter
  this.addOrbiter = function orbit_add_orbiter(id, title, angle, evaluation,getValue,images) {
   if(C11N.tooltips)
    cont.append('<div onmouseover="WTGORBIT.on_tooltips_mouseover(this)"  class="ring '+evaluation+' orbiterBorder orbitTooltip"  style="text-align:center;cursor:pointer" id="'+id+'"><span class="orbitTooltipText"></span><img class="imageAlignementClass '+id+'Class"  src="'+images+'" /></div> ');
   else if(WTG.help_mode){
    cont.append('<div class="ring '+evaluation+' orbiterBorder orbitTooltip"  style="text-align:center;" id="'+id+'"><div class="orbitBubbleText" id="bubble'+id+'"></div><img class="imageAlignementClass '+id+'Class"  src="'+images+'" /><span class="orbitTitleText orbitTitleText_'+id+'">'+help_mode_info[id].title+'</span></div> ');
    $("#bubble"+id).addClass((id == "device") ? "bottomBubble" :"topBubble");
    if((id== "network") || id == "router") {
     var tTitle = (id== "router") ? help_mode_info.provider_line.title : help_mode_info.mobile_line.title;
     var bTitle = (id== "router") ? help_mode_info.wifi_network.title : help_mode_info.mobile_network.title;
     var top = Math.round(sWidthF/4);
     var btm = (id == "network") ? top+40 : top+20;
     $("#"+id).append('<span style="top:'+-top+'px" class="arcTitleText arcTitleText_'+id+'_top">'+tTitle+'</span><span style="bottom:'+-btm+'px" class="arcTitleText arcTitleText_'+id+'_bottom">'+bTitle+'</span>');
    }
   }else
    cont.append('<div  class="ring '+evaluation+' orbiterBorder"  style="text-align:center;" id="'+id+'"><img class="imageAlignementClass '+id+'Class"  src="'+images+'" /></div>');

   $(".ring").css('width',ringDimention+'px').css('height',ringDimention+'px');
   $(".orbitTitleText").css('width',ringDimention+15+'px').css('left',-8+'px');
   $(".arcTitleText").css('width',ringDimention+'px');
   $(".imageAlignementClass").css('width','55%').css('height','55%');
   var o = new orbiter(angler);
   o.init(id, prop.w/2, prop.h/2, prop.r, angle, getValue);
   prop.orbiters[id] = {title:title, o:o, e:undefined};
   this.setStatus(id, evaluation);
  };

  // Change evaluation status
  this.setStatus = function orbit_set_status(id, evaluation) {
   if(evaluation===undefined) return;
   var o = $("#"+id);
   if(prop.orbiters && prop.orbiters[id]) {
    if(prop.orbiters[id].e)o.removeClass(prop.orbiters[id].e);
    prop.orbiters[id].e = evaluation;
   }
   o.addClass(evaluation);
   d.orbiters[id].updateHeader = evaluation;
  };
 }

 var p=[];
 //Orbiter: Object orbiting around the center
 function orbiter(angler_) {
  //var myCanvas = document.getElementById("myCanvas");
  var context= myCanvas.getContext("2d");
  var connector={"unknown":"#C5C5C5","ok":"#B7E200","warn":"#FAAA0C","prob":"#F52201"};
  // Properties: identifier, centre point of the orbit, radius of the orbit, angle at which the object is placed
  var prop = {id:undefined, c:{x:undefined,y:undefined}, r:undefined, a:undefined, s:{w:undefined,h:undefined}};
  // Angles: mapping from degrees to radians
  var angler = angler_;

  function draw_arc(o0,o1,ss) {
   // TODO: what are these constants?
   var a0 = o0/180 + (ringDimention/(ringDimention*1.72));
   var a1 = o1/180 + (ringDimention/(ringDimention*2.4));
   context.lineWidth = 3;
   context.beginPath();
   // TODO: what are these offsets?
   arcs[o0+"-"+o1] = {
    cx:  canvasRadius+3,
    cy: canvasRadius+1,
    radius: canvasRadius,
    start: a0*Math.PI,
    end: a1*Math.PI,
    id:o0+"-"+o1,
    point_cursor:'pointer',
    disable_cursor:'no-drop'
   };
   context.arc(canvasRadius+3,canvasRadius+1,canvasRadius, a0*Math.PI, a1*Math.PI);
   context.strokeStyle = ss;
   context.globalAlpha =( !WTG.capabilities.mobile && ((o0 == 0 && o1 == 90) || (o0 == 90 && o1 == 180)) )? WTG.disabled_comp_opacity : 1 ;
   context.stroke();
   context.closePath();
  }

  // Initialize the orbiter with properties and animate to its angled position
  this.init = function oriber_init(id, x, y, radius, angle, getValue) {
   // Initialize with properties
   canvasRadius = Math.round(sWidthF/2);
   var o = $("#"+id);
   prop = {id:id, c:{x:x,y:y}, r:radius, a:Math.round(angle), s:{w:o.outerWidth(),h:o.outerHeight()}};
   p.push(prop);
   // Position the orbiter at centre
   o.css({position:"absolute", left:x-(prop.s.w/2.2), top:y-(prop.s.h/2.1)});
   // Animate slowly to its angled position
   this.animate(prop.a, true);
   // Draw arcs depending on number of elements
   draw_arc(prop.a,prop.a+360/getOrbitersCount(),connector[getValue]);

   // Click on the orbiter would call the orbit callback to position
   o.click( function on_click_orbiter() {
    $(".orbitBubbleText").hide();
    $(".orbitBubbleText").empty();
    $("#arc_help_bubble").hide();
    ["internet","router","device","network"].forEach(function(i){
     if($("#"+i).hasClass("orbitTooltip_"+i)) $("#"+i).removeClass("orbitTooltip_"+i);
    });
    if(event && event.target && event.target.id === 'bubble_close') return;
    if(WTG.help_mode){
     var help_text = help_mode_info[id].desc;
     var template = '<div id="bubbleHeader"><div id="bubble_close"><img id="bubbleCloseImg" src="'+WTG.img("ic_close_btn.png")+'" /></div></div><div id="bubbleContent">'+help_text+'</div>';
     var ow = sWidth*.9;
     var lt_margin = sWidth*.05;
     var lt = $("#"+id).offset().left;
     L.trace("ow--"+ow+"---id--"+id+"--lt=="+lt);
     L.trace("sWidth--"+sWidth+"---lt_margin--"+lt_margin);
     $("#bubble"+id).html(template);
     $("#bubble"+id).show();
     $("#bubble"+id).css("width",ow+"px").css("left",-(lt-lt_margin)+"px");
     $("#"+id).addClass("orbitTooltip_"+id);
     return;
    }
    for(var orber in d.orbiters) {
     if(prop.a == d.orbiters[orber].pos) {
      if(! WTG.capabilities.mobile && (d.orbiters[orber].n == "mobile_bs")) return;
      showResultsScreen(d.orbiters[orber].n);
      break;
     }
    }
   });
  };

  this.changeArcColor = function orbiter_change_arc_color(sNode,eNode,evalValue) {
   //L.trace('changeArcColor- sNode-'+sNode+"changeArcColor- eNode--"+eNode);
   if(_TDC && (evalValue==='prog')) return;
   var index1 = d.orbiters[sNode].index;
   var index2 = d.orbiters[eNode].index;
   var dindex = Math.abs(index1-index2);
   var rollover = dindex==getOrbitersCount()-1;
   if( Math.max(index1,index2) >= getOrbitersCount()
       || Math.min(index1,index2) < 0
       || (dindex!=1 && !rollover) )
    return L.error({s:sNode,e:eNode},"invalid nodes for an arc"),this;

   var id = (index1 < index2)?sNode+'_'+eNode:eNode+'_'+sNode;
   arcData[id] = {
    state: evalValue,
    ArcIcon1: _TDC ? d.orbiters[sNode].img : d.orbiters[sNode].reportScreenIcon,
    ArcIcon2: _TDC ? d.orbiters[eNode].img : d.orbiters[eNode].reportScreenIcon
   };

   var bSwapIndex = rollover ? index1<index2 : index1>index2;

   draw_arc(p[bSwapIndex?index2:index1].a,p[bSwapIndex?index1:index2].a,ConnectionLineColors[evalValue]);
   return this;
  };

  this.clearArc = function orbiter_clear_arc(getGroupVaues){
   //L.trace('getGroupVaues--'+getGroupVaues);
   context.beginPath();
   var rectArea = Math.round(sWidthF/2);
   context.clearRect(arcRegions[getGroupVaues].x, arcRegions[getGroupVaues].y, rectArea,rectArea);
   context.closePath();
   return this;
  };

  // Animate to its angled position
  this.animate = function orbiter_animate(angled, slow, cb) {
   var pos = {left:Math.round(prop.r*Math.sin(-1*angler[angled])+prop.c.x-(prop.s.w/2.2)), top:Math.round(prop.r*Math.cos(-1*angler[angled])+prop.c.y-(prop.s.h/2.1))};
   $("#"+prop.id).animate(pos, slow?"slow":1, 'swing', cb);
  };

 }
 function handleArcsMousehover(e,cOffset) {
  var mouseX = parseInt(e.clientX - cOffset.left);
  var mouseY = parseInt(e.clientY - cOffset.top);
  var context = myCanvas.getContext("2d");
  for (var arc in arcs ) {
   defineArc(arcs[arc]);
   if(!Object.keys(arcs[arc]).length) continue;
   for (var i = -20; i < 20; i++) {
    var mx = mouseX-i;
    var my = mouseY;
    if (context.isPointInStroke(mx, my)) {
     $("#arcOverlay").css("visibility","visible").css("top",my).css("left",mx);
     if(!WTG.capabilities.mobile && (arcs[arc].id == "0-90" || arcs[arc].id == "90-180" )){
      myCanvas.style.cursor = arcs[arc].disable_cursor;
      $("#arcOverlay").text(_str("main_page_disable_component_tooltip"));
     }else {
      myCanvas.style.cursor = arcs[arc].point_cursor ;
      $("#arcOverlay").text(_str("main_page_circle_tooltip"));
     }
     return;
    }
    myCanvas.style.cursor='default';
    $("#arcOverlay").css("visibility","hidden");
   }
  }
  function defineArc(a) {
   context.beginPath();
   context.arc(a.cx, a.cy, a.radius, a.start, a.end);
  }
 }

 function onManageToolTips(e) {
  $("#arcOverlay").css("visibility","hidden");
  var more_text = ((e.id == "network") && !WTG.capabilities.mobile) ? _str("main_page_disable_component_tooltip") : _str("main_page_circle_tooltip") ;
  $(".orbitTooltipText").html(d.orbiters[e.id].t+'<span class="font_12"><br>'+more_text+'</span></span>');
 }
 function onManageCenterTextTooltips(/*e,cOffset*/) {
  //var mouseX = parseInt(e.clientX - cOffset.left);
  //var mouseY = parseInt(e.clientY - cOffset.top);
  //$("#arcOverlay").css("visibility","visible").css("top",mouseY-50).css("left",mouseX);
  setCenterStatusCursorPoint(Object.keys(TR.evalz.prob).length || Object.keys(TR.evalz.warn).length);
 }

 /*
 In portrait mode orbit_width variable calculates 65 percentage in
 total screen width (excluding top,bottom areas and margins).
 In landscape mode orbit_height variable calculates 50 percentage
 in total screen height (excluding top,bottom areas and margins).
 */
 function calculateOrbitWidth(swidth,sheight){
  var per=_portrait ? ((sheight<600)? (WTG.help_mode ? 50 : 60) : 65) : (_TDC ? 40 : 45);
  var orbit_width = 0;
  var orbit_height= 0;
  var other_controls_height = 100;
  var top_header = _TDC ? 15 : 8; //For TDC considered 15% for top_header(including tabs container).For h2g considered 8% as it wont have tabs but top header.
  var bottom_text = 15;// considered 15% for bottom text
  var margins = 20; //considered 20% for all margins.
  var corp = c11n.features.vpn?15:0; //For corporate version considered 15% to show corporate icon above the main circle.
  other_controls_height -= (top_header + bottom_text + margins + corp);
  if(_portrait){
   orbit_width = Math.round(swidth*per/100);
   var avail_height = Math.round(sheight*other_controls_height/100);
   if(avail_height >= orbit_width) return orbit_width;
   return avail_height;
  }
  per -= c11n.features.vpn?15:0;
  orbit_height = Math.round(sheight*per/100);
  var avail_width = Math.round(swidth*.90); // 10% for margins
  if(avail_width >= orbit_height) return orbit_height;
  return avail_width;
 }

 function checkClientCoordinates(swidth){
  var img = $('#hsBackgroundImg');

  //Image display width
  var d_width = img.width();

  //Here we are comparing width only.because height always 100% only width will change according to device height
  //if the device width greater than to image loaded width then we are taking the image center part for eliminating image stretch.
  L.trace('sWidth: ' + swidth + ' d_width ' + d_width);
  if(swidth > d_width) img.removeClass("hsBackgroundImgCls").addClass("hsBgImgCenterBlock");

 }
 function handle_help_mode_text_on_arcs(e,is_arc) {
  function defineArc(arc_) {
   context.beginPath();
   context.arc(arc_.cx, arc_.cy, arc_.radius, arc_.start, arc_.end);
  }
  L.trace("handle_help_mode_text_on_arcs");
  var cOffset = $("#myCanvasId").offset();
  $(".orbitBubbleText").hide();
  ["internet","router","device","network"].forEach(function(id){
   if($("#"+id).hasClass("orbitTooltip_"+id)) $("#"+id).removeClass("orbitTooltip_"+id);
  });
  var mouseX = parseInt(e.clientX - cOffset.left);
  var mouseY = parseInt(e.clientY - cOffset.top);
  var context = myCanvas.getContext("2d");
  var ow = sWidth*.9;
  var lt_margin = sWidth*.05;
  var canvas_left = cOffset.left;
  var template = '<div class="arc_bubble_arrow"></div><div id="bubbleHeader"><div id="bubble_close"><img id="bubbleCloseImg" src="'+WTG.img("ic_close_btn.png")+'" /></div></div><div id="bubbleContent"></div>';
  $("#arc_help_bubble").html(template);
  $("#bubble_close").click(function on_bubble_close(){
   $("#arc_help_bubble").hide();
  });
  if(is_arc){
   for (var arc in arcs ) {
    defineArc(arcs[arc]);
    if(!Object.keys(arcs[arc]).length) continue;
    var mx = mouseX + 15 /*-i there was a funny loop.*/;
    var my = mouseY;
    var help_text ="";
    if(!context.isPointInStroke(mx, my)) {
     $("#arc_help_bubble").hide();
     return;
    }
    switch(arcs[arc].id){
     case "0-90":
     help_text = help_mode_info.mobile_network.desc;
     break;
     case "90-180":
     help_text = help_mode_info.mobile_line.desc;
     break;
     case "180-270":
     help_text = help_mode_info.provider_line.desc;
     break;
     case "270-360":
     help_text = help_mode_info.wifi_network.desc;
     break;
     default:
     L.trace("no arc");
    }
    $("#bubbleContent").html(help_text);
    $("#arc_help_bubble").show();
    $("#arc_help_bubble").css("width",ow+"px").css("left",-(canvas_left-lt_margin)+"px").css("top",my+20);
    $(".arc_bubble_arrow").css("left",(e.clientX-lt_margin)+"px");
    return;
   }
  }else{
   $("#bubbleContent").html(help_mode_info.center.desc);
   $("#arc_help_bubble").show();
   $("#arc_help_bubble").css("width",ow+"px").css("left",-(canvas_left-lt_margin)+"px").css("top",mouseY+10);
   $(".arc_bubble_arrow").css("left",(e.clientX-lt_margin)+"px");
  }
 }

 return {
  set_status: function wtgorbit_set_status(group,result) {
   d.orbit.setStatus(group,result);
  },
  // XXX: this direct accessor is probably just the first step.
  get_orbiter: function wtgorbit_get_orbiter(group) {
   return d.orbiters[group];
  },
  get_connector: function wtgorbit_get_connector(group) {
   return d.arcs[group];
  },
  // XXX: this shouldn't even exist, of course, but will take care of it later
  eval_from_eval: function wtgorbit_eval_from_eval(evaluation,domap) {
   return domap ? resultEvaluationMapping["eval_"+evaluation] : evaluation;
  },
  bar_state: function wtgorbit_bar_state() {
   if(!arguments.length) return stateForStatusBarColor;
   stateForStatusBarColor=arguments[0];
   return this;
  },
  rsd: function wtgorbit_rsd() {
   return reportScreenData;
  },
  arc_data: function wtgorbit_arc_data(id) {
   return arcData[id];
  },
  is_wide: function wtgorbit_is_wide() {
   return sWidthF > 180;
  },
  create_orbit: CreateOrbit,
  corp_server_color: setCorpServerColor,
  corp_server_icon: setCorpServerIcon,
  lock_icon: showLockIcon,
  handle_help_mode_text_on_arcs :handle_help_mode_text_on_arcs,
  make_orbiter: function wtg_make_orbiter(a) {
   return new orbiter(a);
  },
  on_tooltips_mouseover: onManageToolTips
 };
})();
/* vim:set ts=4 sw=1 expandtab: */
